module.exports = __webpack_public_path__ + "static/media/icon_descend.aa51df0f.svg";